import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { forwardRef, useMemo } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import merge from 'deepmerge';
import { useThemeContext } from '../ThemeProvider/ThemeContext.js';
import ButtonBase from './Base/ButtonBase.js';
import ButtonLoading from './Base/ButtonLoading.js';
import IconButton from './Base/IconButton.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ButtonPrimary = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      theme = props.theme,
      loading = props.loading,
      icon = props.icon,
      otherProps = _objectWithoutProperties(props, ["children", "theme", "loading", "icon"]);

  var themeTokens = useThemeContext();
  var styleObject = useMemo(function () {
    return merge.all([_objectSpread(_objectSpread(_objectSpread({}, themeTokens.primaryColorHover ? {
      '&:hover': {
        background: themeTokens.primaryColorHover
      }
    } : {}), themeTokens.primaryColorActive ? {
      '&:active': {
        background: themeTokens.primaryColorActive
      }
    } : {}), themeTokens.primaryColor ? {
      background: themeTokens.primaryColor
    } : {}), theme]);
  }, [themeTokens, theme]);
  var loadingStyle = 'btnPrimary_btnLoading';

  if (icon) {
    return jsx(IconButton, _extends({}, props, {
      theme: styleObject,
      ref: ref,
      loadingStyle: loadingStyle,
      styled: true
    }), children);
  }

  if (loading) {
    return jsx(ButtonLoading, _extends({}, otherProps, {
      theme: styleObject,
      ref: ref,
      loadingStyle: loadingStyle,
      styled: true
    }), children);
  }

  return jsx(ButtonBase, _extends({}, otherProps, {
    theme: styleObject,
    ref: ref,
    styled: true
  }), children);
});
ButtonPrimary.displayName = 'ButtonPrimary';
ButtonPrimary.defaultProps = {
  children: '',
  loading: false,
  size: undefined,
  type: 'button',
  theme: {}
};

export default ButtonPrimary;
